import { FilterSetType } from '@statsbomb/parachute-types';
import { atom } from 'jotai';
import { UserConfigActions, UserConfigType } from '@/types/userConfigs';

export const userConfigIdAtom = atom<string | null>(null);
export const userConfigActionAtom = atom<UserConfigActions | null>(null);
export const userConfigNameAtom = atom<string | null>(null);
export const userConfigTypeAtom = atom<UserConfigType | null>(null);

export const resetUserConfigActionStateAtom = atom(null, (_get, set) => {
  set(userConfigIdAtom, null);
  set(userConfigActionAtom, null);
  set(userConfigTypeAtom, null);
  set(userConfigNameAtom, null);
});

export const iSaveFilterSetModalOpenAtom = atom(get => {
  const userConfigAction = get(userConfigActionAtom);
  const userConfigType = get(userConfigTypeAtom);

  const isFilterSetConfig = userConfigType === FilterSetType.FILTERS;
  const isSavingNewConfig =
    userConfigAction === UserConfigActions.CREATE || userConfigAction === UserConfigActions.DUPLICATE;

  return isFilterSetConfig && isSavingNewConfig;
});

export const isGenericRenameModalOpenAtom = atom(get => {
  const userConfigIdToAmend = get(userConfigIdAtom);
  const userConfigAction = get(userConfigActionAtom);
  const isRenameMode = userConfigAction === UserConfigActions.RENAME;

  return !!userConfigIdToAmend && isRenameMode;
});

export const isGenericDeleteModalOpenAtom = atom(get => {
  const userConfigIdToAmend = get(userConfigIdAtom);
  const userConfigAction = get(userConfigActionAtom);
  const userConfigType = get(userConfigTypeAtom);
  const isDeleteMode = userConfigAction === UserConfigActions.DELETE;

  return !!userConfigIdToAmend && !!userConfigType && isDeleteMode;
});

export const isShareUserConfigModalOpenAtom = atom(get => {
  const userConfigIdToAmend = get(userConfigIdAtom);
  const userConfigAction = get(userConfigActionAtom);
  const isShareMode = userConfigAction === UserConfigActions.SHARE;

  return !!userConfigIdToAmend && isShareMode;
});

export const openShareModalAtom = atom(null, (_get, set, configId: string) => {
  set(userConfigIdAtom, configId);
  set(userConfigActionAtom, UserConfigActions.SHARE);
});
